import views from '@/views/';

export default [
  {
    component: views.memberManagement.list,
    label: '会员列表',
    path: 'list',
    name: 'list',
  },
  {
    component: views.memberManagement.addVIPCard,
    label: '添加VIP卡类型',
    path: 'addVIPCard/:id',
    name: 'addVIPCard',
    menuHidden: true,
  },
  {
    component: views.memberManagement.vipMember,
    label: 'VIP平台会员',
    path: 'vipMember',
    name: 'vipMember',
  },
  {
    component: views.memberManagement.rechargeRecord,
    label: '充值记录',
    path: 'rechargeRecord',
    name: 'rechargeRecord',
  },
  {
    component: views.memberManagement.managementSmsRecord,
    label: '短信记录',
    path: 'managementSmsRecord',
    name: 'managementSmsRecord',
  },
  {
    component: views.memberManagement.mangementCouponRecord,
    label: '优惠券记录',
    path: 'mangementCouponRecord',
    name: 'mangementCouponRecord',
  },
];
